import React, { Component, KeyboardEvent } from "react";
import { IAppLoginState, ILoader } from "../index";
import Strings, { LVStrings } from "@my-dld/assets/strings";
import TextInputField from "@my-dld/components/Form/TextInputField";
import { EIDModal } from "../owner/EID";
import { I8N, LocaleUtil, StringUtil } from "@eres/core";
import { SSOApi } from "@eres/ssoapi";
import { exToMessage, getUaePassUrl } from "@eres/ssoapi/api";
import VerifyPopup from "@my-dld/components/VerifyPopup";
import { setSSOUser } from "@my-dld/utils/User";
import { dispatch, navigate, navigateWithInParent } from "@my-dld/utils/StoreUtils";
import { SavedLoginAction } from "@my-dld/actions";
import { PickerItem } from "@my-dld/components/Picker";
import ReCAPTCHA from "react-google-recaptcha";
import EIDInputConverter from "@my-dld/components/Form/Converters/EidConverter";
import { EidInputClassProvider } from "@my-dld/components/FixedEidInput";
import { getAppServices } from "@10x/coreapp";
import { BaseLoginScreen, LoginOptions } from "../BaseLoginScreen";
import { AppConstants } from "../../../configApp";
import { hideLoading, showLoading } from "@my-dld/utils/UIUtils";
import { getCriticalNotifications, getNotificationUrl, isValidForOperation } from "@my-dld/utils/UserNotificationHandler";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import * as base64 from "js-base64";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";
import { SSOProfile } from "@10x/sso/SSOProfile";
import { navigateToSSOApp } from "../utils";
import { featureGateCheck } from "@my-dld/utils/Utils";
import { SSOApp } from "../../../../typings/global";

// const res = {
// 	"response": {
// 		"userAccountId": 1231231,
// 		"templateUrl": "https://gateway.dubailand.gov.ae/ssoapi/templates/nda-1.0.0.html",
// 		"templateVersion": "1.0.0",
// 		"userType": {
// 			"id": 1231231,
// 			"name": {
// 				"englishName": "",
// 				"arabicName": ""
// 			}
// 		},
// 		"role": {
// 			"id": 1231231,
// 			"name": {
// 				"englishName": "",
// 				"arabicName": ""
// 			}
// 		},
// 		"fullNameEn": "Rumail Nazir",
// 		"fullNameAr": "Rumail Nazir",
// 		"email": "rumail.nazir@bankalfalah.com",
// 		"emiratesId": "78419735234234234",
// 		"hasNDA": false,
// 		"applicationUserProfiles": [
// 			{
// 				"id": 1232,
// 				"name": {
// 					"englishName": "",
// 					"arabicName": ""
// 				},
// 				"designation": {
// 					"englishName": "",
// 					"arabicName": ""
// 				}
// 			},
// 			{
// 				"id": 1232,
// 				"name": {
// 					"englishName": "",
// 					"arabicName": ""
// 				},
// 				"designation": {
// 					"englishName": "",
// 					"arabicName": ""
// 				}
// 			},
// 			{
// 				"id": 1232,
// 				"name": {
// 					"englishName": "",
// 					"arabicName": ""
// 				},
// 				"designation": {
// 					"englishName": "",
// 					"arabicName": ""
// 				}
// 			},
// 			{
// 				"id": 1232,
// 				"name": {
// 					"englishName": "",
// 					"arabicName": ""
// 				},
// 				"designation": {
// 					"englishName": "",
// 					"arabicName": ""
// 				}
// 			},
// 			{
// 				"id": 1232,
// 				"name": {
// 					"englishName": "",
// 					"arabicName": ""
// 				},
// 				"designation": {
// 					"englishName": "",
// 					"arabicName": ""
// 				}
// 			}
// 		]
// 	},
// 	"timeStamp": "2024-01-29T16:00:47.2376691+04:00",
// 	"responseCode": 200,
// 	"validationErrorsList": [
// 		{
// 			"exceptionObject": null,
// 			"errorNumber": 4001,
// 			"errorMessageSet": null,
// 			"validationType": 3,
// 			"errorMessage": "LOGIN_ATTEMPT_FAILED",
// 			"items": null
// 		}
// 	]
// };

interface Params {
	appId?: string;
	callback?: string;

}

interface Prop extends RoutedViewProps <Params> {
}

interface State {
	loginType?: PickerItem;
	step: "form" | "verify";
	eid?: string;
	error?: string;
	token?: string;
	email?: string;
	mobileNumber?: string;
	isPassCode: boolean;
	LoginChannels: PickerItem[];
	ssoPassword?: string;
	ssoUsername?: string;
	formErrors: { [ k: string ]: string };
	captchaResponse?: string;
	captchaError?: string;
	showCaptcha: boolean;
	loginTarget: string;
	isSSOLogin?: boolean;
	ssoAppId?: string;
	ssoCallBack?: string;
	showMobileOTP: boolean;
	applications: SSOApp[];
	selectedApplication?: SSOApp;


}

// const LoginTypes: PickerItem[] = [
// 	{
// 		id: "sso-eid",
// 		value: LVStrings.emirates_id
// 	},
// 	{
// 		id: "sso-pass",
// 		value: LVStrings.username_password
// 	},
// ];

class SSOChannel extends Component<Prop, State> {
	vp = React.createRef<VerifyPopup>();
	captcha = React.createRef<ReCAPTCHA>();

	constructor( props: Prop ) {
		super( props );
		const savedEid = getAppServices().storeService.getStore().getState().User?.savedLogin?.eid;
		// let availableTypes = LoginTypes;
		// if ( window && window.AppInfo && window.AppInfo.config && window.AppInfo.config.disabledSSOLogins && Array.isArray( window.AppInfo.config.disabledSSOLogins ) ) {
		// 	const disabled: string[] = window.AppInfo.config.disabledSSOLogins;
		// 	availableTypes = LoginTypes.filter( t => disabled.indexOf( t.id ) === -1 );
		// }
		let { appId, callback } = props.match.params;
		let isSSOAppLogin = !isEmptyStringOrNull( appId );

		const loginChannels = [ {
			id: "sso-pass",
			value: LVStrings.username_password
		}, {
			id: "sso-eid",
			value: LVStrings.emirates_id
		} ];

		this.state = {
			step: "form",
			eid: savedEid ? savedEid : window.setOTP ? "784198657419035" : "784",
			isPassCode: false,
			LoginChannels: [ {
				id: "sso-pass",
				value: LVStrings.username_password
			}, {
				id: "sso-eid",
				value: LVStrings.emirates_id
			} ],
			loginType: loginChannels[ 0 ],
			formErrors: {},
			showCaptcha: window.AppInfo.noCaptcha !== true,
			loginTarget: ( props.location && props.location.state && props.location.state.from ) ?
				props.location.state.from : "/mydld",
			isSSOLogin: isSSOAppLogin,
			ssoAppId: appId,
			ssoCallBack: callback,
			showMobileOTP: featureGateCheck( "showMobileOTP" ),
			applications: this.sortedApps(),


		};
	}

	sortedApps = () => {
		if ( I8N.isRTL() ) {
			return window.ssoApps.sort( ( a, b ) => a.name.ar!.localeCompare( b.name.ar! ) );
		} else {
			return window.ssoApps.sort( ( a, b ) => a.name.en!.localeCompare( b.name.en! ) );
		}
	};

	updateLoginChannels = () => {
		let arrLoginChannels = [];
		if ( this.state.selectedApplication?.allowedAuthenticationMethods?.userNamePassword ) {
			arrLoginChannels.push( {
				id: "sso-pass",
				value: LVStrings.username_password
			} );
		}
		if ( this.state.selectedApplication?.allowedAuthenticationMethods?.emiratesID ) {
			arrLoginChannels.push( {
				id: "sso-eid",
				value: LVStrings.emirates_id
			} );
		}
		this.setState( { LoginChannels: arrLoginChannels, loginType: arrLoginChannels.length > 0 ? arrLoginChannels[ 0 ] : undefined } );
	};

	onTypeChange = ( id: string ) => {
		const { LoginChannels } = this.state;
		this.setState( { loginType: LoginChannels.find( x => x.id === id ) } );
	};
	onSwitchToOther = () => {
		navigateWithInParent( "login", "owner" );
	};

	render() {
		const { mobileNumber, email, error, isPassCode, showMobileOTP } = this.state;
		const { loginType } = this.state;
		const channelId = loginType?.id;
		const otps: string[] = [];
		if ( showMobileOTP && mobileNumber ) otps.push( mobileNumber );
		if ( email ) otps.push( email );
		// const modifiedOTPMessage = showMobileOTP ?
		// 	Strings.we_have_sent_pass_code_to_your_registered_mobile_number + ( email ? ( " / " + Strings.email ) : "" ) :
		// 	Strings.we_have_sent_pass_code_to_your_registered_email_id
		const modifiedOTPMessage = mobileNumber ? Strings.we_have_sent_pass_code_to_your_registered_mobile_number + " " + mobileNumber + ( email ? ( " / " + Strings.email ) : "" ) :
			Strings.we_have_sent_pass_code_to_your_registered_email_id + ( email ? ( " / " + Strings.email ) : "" );

		const UAEPassIcon = `Button_UAE_Pass_${ I8N.locale() }_Login`;

		return ( <>
				<BaseLoginScreen containerClass="auth-container sso-wrap">
                <div className="container" id="businessUser">
                    <div className="row g-0 align-items-center justify-content-center">
                        <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-8 col-sm-12 col-12">
                            <div className="auth-container-form card">
                                <div className="auth-title">
                                    <span>{ Strings.login_as_business_user_via }</span>
                                    <button
                                        className="btn-link btn-switch-user" onClick={ this.onSwitchToOther }
                                        id="switchIndividual">{ Strings.login_as_individual }</button>
                                </div>
                                {/*<div className="sso-app-selection">*/}
                                {/*    <PickerInput*/}
                                {/*        inputClassName="form-select"*/}
                                {/*        id={ "selectedApplication" }*/}
                                {/*        holder={ this }*/}
                                {/*        required={ true }*/}
                                {/*        label={ Strings.select_application }*/}
                                {/*        items={ this.state.applications }*/}
                                {/*        formatter={ ( item ) => I8N.isRTL() ? item.name.ar ?? "" : item.name.en ?? "" }*/}
                                {/*        toIdentifier={ ( item: SSOApp ) => item.id + "" }*/}
                                {/*        onValueChange={ ( scope: any ) => {*/}
                                {/*            this.setState( { selectedApplication: scope }, () => {*/}
                                {/*	            this.updateLoginChannels();*/}
                                {/*            } );*/}
                                {/*            //  this.props.onValuationScopeChange( scope );*/}
                                {/*        } }*/}
                                {/*    />*/}
                                {/*</div>*/}
                                {/*{ this.state.selectedApplication?.allowedAuthenticationMethods?.uaePass &&*/}
                                <div className="uae-pass-wrapper">
                                    <div className="uae-pass-msg hide">Login to Oqood Application will be via UAE Pass only. For help regarding login
                                    kindly
                                    contact support team.
								</div>
                                    <button className="btn btn-login-uaepass" onClick={ this.onUaePass }>
                                        <span className="sr-only">Login with UAE Pass</span>
                                    </button>
                                    <div className="uae-pass-registration">
                                        <span>{ Strings.dont_have_uae_pass_account } <a
                                            href="https://uaepass.ae/" rel="noopener noreferrer" target="_blank">{ Strings.create_new_account }</a></span>
                                        <span>{ Strings.how_to_register_for_uae_pass } <a
                                            href={ Strings.watch_video_link } rel="noopener noreferrer" target="_blank">{ Strings.watch_video }</a></span>
                                    </div>
                                </div>
                                { this.state.LoginChannels && this.state.LoginChannels.length > 0 &&
                                    <div className="sso-or-div"><span>{ Strings.or_caps }</span></div> }
                                <div className="sso-manual-login">
                                    <LoginOptions
                                        items={ this.state.LoginChannels } checkedId={ channelId ?? "" }
                                        onChange={ this.onTypeChange }/>
                                    <div className="auth-container-form" id="emiratesID">
                                        { channelId === "sso-eid" && <>
                                            <TextInputField
                                                containerClassName={ "form-group" }
                                                inputClassName={ "form-control" }
                                                placeHolder={ "784-XXXX-XXXXXX-X" }
                                                id={ "eid" }
                                                holder={ this }
                                                error={ error }
                                                label={ Strings.emirates_id_number }
                                                maxLength={ 15 }
                                                inputProps={ { onKeyPress: this.onKeyUp } }
                                                converter={ EIDInputConverter }
                                                inputClassProvider={ EidInputClassProvider }
                                            >
                                                <a
                                                    data-bs-target="#emiratesIDInfoModal" data-bs-toggle="modal"
                                                    href="#" className={ "login-input-info" }>
                                                    <span className="sr-only">Information Icon</span>
                                                    <span className="fa fa-info-circle info-icon-input"/></a>
                                            </TextInputField>
                                            <EIDModal/>
                                        </> }
                                        { channelId === "sso-pass" && <>
                                            <div className="row row-cols-1 row-cols-sm-2 g-3 g-sm-4">
                                                <TextInputField
                                                    containerClassName={ "col" }
												    inputClassName={ "form-control" }
												    placeHolder={ Strings.user_name }
												    id={ "ssoUsername" }
												    required={ true }
												    hideRequiredStar={ true }
												    holder={ this }
												    error={ this.state.formErrors.ssoUsername }
												    label={ Strings.user_name }
												    maxLength={ 250 }
                                                />
                                                <TextInputField
                                                    required={ true }
												    hideRequiredStar={ true }
												    containerClassName={ "col" }
												    inputClassName={ "form-control" }
												    placeHolder={ Strings.password }
												    id={ "ssoPassword" }
												    holder={ this }
												    error={ this.state.formErrors.ssoPassword }
												    label={ Strings.password }
												    maxLength={ 250 }
												    inputProps={ {
												    	type: "password",
												    	onKeyPress: this.onKeyUp,
												    } }
                                                />
                                            </div>
                                            <a
                                                href="#/sso/forgot"
                                                className={ "forgot-password-link" }>{ Strings.forgot_username_password }</a>
                                        </> }
                                        { this.state.showCaptcha &&
										<div className="captcha-control">
											<ReCAPTCHA
												ref={ this.captcha }
												sitekey={ window.AppInfo.recaptchaSiteKey! }
												hl={ I8N.locale() }
												onChange={ this.onCaptchaChange }
												onErrored={ this.onCaptchaExpired }
												onExpired={ this.onCaptchaExpired }
											/>
											{ this.state.captchaError && <div className={ "invalid-feedback invalid-feedback-x" }>
												{ this.state.captchaError }
											</div> }
										</div> }
                                        <div className="form-group">
                                            <button
                                                className="btn btn_style1 btn_1 btn-block fs-5"
                                                onClick={ this.doLogin }>{ Strings.login }</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
					{ this.state.step === "verify" &&
						<VerifyPopup
							showPasscodeAnnouncement={ window.AppInfo.showPasscodeHelpForSSO }
							ref={ this.vp }
							hideVCode={ isPassCode }
							id={ "login_eid_otp" }
							message={ isPassCode ? Strings.please_enter_your_pass_code : ( modifiedOTPMessage + "\n" + otps.join( " / " ) ) }
							maxLength={ 7 }
							onDismiss={ this.onVerifyDismiss }
							onVerify={ this.onVerify }
							hasResend={ true }
							resend_label={ Strings.forgot_passcode }
							resend_label_link={ Strings.resend }
							onResend={ this.regenPassCode }
							loginId={ this.state.eid }
						/> }
				</BaseLoginScreen>
			</>
		);
	}

	onUaePass = () => {
		console.log( "UAEPass URL CALLED" );
		console.log( "UAEPass URL CALLED STATE", this.state );
		const ln = I8N.locale();
		const appState: IAppLoginState = {
			module: "uaepass",
			sso: true,
			app: this.state.ssoAppId,
			cb: this.state.ssoCallBack,
			ln: ln,
			mode: "login",
		};
		const state = base64.encode( JSON.stringify( appState ) );
		const passUrl = getUaePassUrl( ln, state );
		console.log( "UAEPAss URL origin", passUrl );
		window.location.href = passUrl;
	};
	onCaptchaChange = ( token: string | null ) => {
		this.setState( { captchaResponse: token!, captchaError: undefined } );
	};
	onCaptchaExpired = () => {
		this.setState( { captchaResponse: undefined } );
	};
	resetCaptcha = () => {
		if ( this.captcha.current ) this.captcha.current.reset();
		this.setState( { captchaResponse: undefined } );
	};
	onKeyUp = ( event: KeyboardEvent<any> ) => {
		if ( event.charCode === 13 ) {
			this.doLogin();
		}
	};
	regenPassCode = () => {
		return SSOApi.login.generatePassCode( "eid" ).then( r => {
			this.setState( {
				isPassCode: false,
				email: r.data.email,
				mobileNumber: r.data.mobileNumber,
			} );
		} ).catch( e => {
			return exToMessage( e ).then( msg => {
				throw msg.error;
			} );
		} );
	};
	onVerify = ( otp: string ) => {
		return SSOApi.login.verifyPassCode( otp!, "eid" ).then( () => {
			return SSOApi.profile.me().then( r => {
				return () => {
					setSSOUser( r.data );
					this.redirect();
				};
			} );

		} ).catch( e => {
			return exToMessage( e )
			.then( SSOApi.profile.handleProfileException )
			.then( correction => {
				const isCorrected = correction.action.task( correction.data );
				if ( isCorrected ) {
					return () => {
						this.redirect();
					};
				}
				return Promise.reject( correction.error );
			} )
			.catch( msg => {
				throw msg.error;
			} );
		} );

	};
	onVerifyDismiss = () => {
		this.setState( { step: "form" } );
	};

	redirect = () => {
		console.log( "REDIRECT CALLED" );
		const validForOperation = isValidForOperation();
		if ( !validForOperation ) {
			const criticalNotifications = getCriticalNotifications();
			if ( criticalNotifications ) {
				const fcn = criticalNotifications.map( x => getNotificationUrl( x ) ).filter( x => x != null );
				if ( fcn.length > 0 ) {
					const to = fcn[ 0 ]!;
					const fc = criticalNotifications.find( x => getNotificationUrl( x ) === to );
					this.props.history.replace( this.state.loginTarget, { notification: fc } );
				}
			} else {
				this.props.history.replace( this.state.loginTarget );
			}
			return;
		}
		if ( this.state.isSSOLogin ) {
			const profile = SSOProfile.getProfile();
			if ( profile ) {
				if ( getCriticalNotifications() != null ) {
					navigate( "/mydld" );
					return;
				}
				if ( profile.applications && this.state.ssoAppId ) {
					const app = profile.applications.find( x => x.applicationId + "" === this.state.ssoAppId );
					if ( app ) {
						showLoading();
						if ( this.state.ssoCallBack ) {
							navigateToSSOApp( this.state.ssoCallBack! );
						} else {
							const xApp = window.ssoApps.find( x => x.id === this.state.ssoAppId );
							if ( xApp && xApp.url && xApp.isLive ) {
								navigateToSSOApp( LocaleUtil.getLocalValue( xApp.url ) );
							}
						}
						return;
					} else {
						const xApp = window.ssoApps.find( x => x.id === this.state.ssoAppId );
						let url = LocaleUtil.getLocalValue( xApp?.url );
						if ( xApp && ( url || this.state.ssoCallBack ) && xApp.universalApp ) {
							if ( this.state.ssoCallBack ) {
								navigateToSSOApp( this.state.ssoCallBack );
							} else if ( url.startsWith( "#" ) ) {
								let xp = url.substr( 1 );
								navigate( xp );
							} else
								navigateToSSOApp( url );
						} else if ( this.props.history ) {
							this.props.history.replace( {
								pathname: "/sso/noapp/" + this.state.ssoAppId!,
								search: this.props.location.search
							} );
						}
					}

				}
			}
		} else {
			console.log( "Redirect to", this.state.loginTarget );
			if ( this.props.history ) {
				this.props.history.replace( this.state.loginTarget );
			}
		}
	};

	doLoginEid( loader: ILoader ): Promise<boolean> {
		this.setState( { captchaError: undefined } );
		if ( StringUtil.isEmptyStringOrNull( this.state.eid ) ) {
			this.setState( { error: Strings.required } );
		} else if ( this.state.eid?.length !== 15 ) {
			this.setState( { error: Strings.invalid_eid } );
		} else if ( this.state.showCaptcha && StringUtil.isEmptyStringOrNull( this.state.captchaResponse ) ) {
			this.setState( { captchaError: Strings.required } );
		} else {
			dispatch( SavedLoginAction.SAVE_EID, this.state.eid );
			SSOApi.login.eid( this.state.eid!, this.state.showCaptcha ? this.state.captchaResponse! : "" )
			.then( r => {
				this.resetCaptcha();
				loader.setLoading( false );
				this.setState( {
					step: "verify",
					token: r.data.token,
					mobileNumber: r.data.mobileNumber,
					email: r.data.email,
					isPassCode: r.data.passCode === "OLD",
				} );

			} )
			.catch( e => {
				this.resetCaptcha();
				exToMessage( e ).then( message => {
					loader.setLoading( false );
					this.setState( { error: message.error } );
				} );
			} );
			return Promise.resolve( true );
		}
		loader.setLoading( false );
		return Promise.resolve( false );
	}

	doLoginPassword( loader: ILoader ): Promise<boolean> {
		this.setState( { captchaError: undefined } );
		const userName = this.state.ssoUsername!;
		const password = this.state.ssoPassword!;
		let isValid = true;
		if ( StringUtil.isEmptyStringOrNull( userName ) ) {
			this.setState( s => {
				return {
					formErrors: {
						...s.formErrors,
						ssoUsername: Strings.required,
					}
				};
			} );
			isValid = false;
		}
		if ( StringUtil.isEmptyStringOrNull( password ) ) {
			this.setState( s => {
				return {
					formErrors: {
						...s.formErrors,
						ssoPassword: Strings.required,
					}
				};
			} );
			isValid = false;
		}
		if ( isValid ) {
			if ( this.state.showCaptcha && StringUtil.isEmptyStringOrNull( this.state.captchaResponse ) ) {
				this.setState( { captchaError: Strings.required } );
				isValid = false;
			}
		}
		if ( isValid ) {
			SSOApi.login.user( userName, password, this.state.showCaptcha ? this.state.captchaResponse! : "" ).then( () => {
				return SSOApi.profile.me().then( r => {
					this.resetCaptcha();
					loader.setLoading( false );
					console.log( "SSO DATA ", r.data );
					setSSOUser( r.data );
					if ( window.PasswordCredential && navigator.credentials && navigator.credentials.create ) {
						return navigator.credentials.create( {
							password: {
								id: userName,
								password: password
							}
						} as any )
						.then( c => {
							if ( c )
								return navigator.credentials.store( c ).then( () => {
									this.redirect();
									return Promise.resolve();
								} );
							else {
								this.redirect();
								return Promise.resolve();
							}
						} )
						.catch( () => {
							this.redirect();
							return Promise.resolve();
						} );
					} else {
						this.redirect();
						return Promise.resolve();
					}
				} );
			} ).catch( e => {
				this.resetCaptcha();
				loader.setLoading( false );
				return exToMessage( e )
				.then( SSOApi.profile.handleProfileException )
				.then( correction => {
					const isCorrected = correction.action.task( correction.data );
					if ( isCorrected ) {
						this.redirect();
						return Promise.resolve();
					}
					return Promise.reject( correction.error );
				} )
				.catch( msg => {
					this.setState( s => {
						return {
							formErrors: {
								...s.formErrors,
								ssoPassword: msg.error,
							}
						};
					} );
				} );
			} );
			return Promise.resolve( true );
		} else {
			loader.setLoading( false );
		}
		return Promise.resolve( false );
	}

	setLoading = ( isLoading: boolean ) => {
		if ( isLoading ) {
			showLoading();
		} else hideLoading();
	};

	doLogin = () => {
		const loader = this;
		if ( this.state.loginType == null ) return Promise.resolve( false );
		loader.setLoading( true );
		this.setState( { error: undefined, formErrors: {} } );
		let id = this.state.loginType.id;
		if ( id === "sso-eid" ) {
			return this.doLoginEid( loader );
		} else if ( id === "sso-pass" ) {
			return this.doLoginPassword( loader );
		}
		loader.setLoading( false );
		return Promise.resolve( false );
	};
}

export default SSOChannel;
